import { render, staticRenderFns } from "./SwitchArrayValue.vue?vue&type=template&id=549b849a"
import script from "./SwitchArrayValue.vue?vue&type=script&lang=js"
export * from "./SwitchArrayValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports